var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.clicked}},[_c('Icon',{staticClass:"expand-icon",class:{ rotated: _vm.value },attrs:{"name":"keyboard_arrow_right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }